
import { Component } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';

@Component({
  components: { VFormBuilder },
})
export default class NutritionForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  public nutritionTableFileRemoved: boolean = false;

  get initVals() {
    return (this.initialValues as any) || {};
  }

  get additionalOptions() {
    return [
      { text: this.$t('venue.form.pdfUpload'), value: true },
      { text: this.$t('venue.form.insertLink'), value: false },
    ];
  }

  get items() {
    return [
      {
        name: 'nutritionTableAsFile',
        type: InputType.Radio,
        default: true,
        label: 'venue.form.secureCode',
        items: this.additionalOptions,
      },
      { name: 'nutritionInfo', type: InputType.Language, useTextarea: true, label: 'venue.form.nutritionInfo' },
    ];
  }

  public removeNutritionTable() {
    this.$confirm().then((res: boolean) => {
      if (res) {
        this.$refs.form.setValue('nutritionTable', '');
        this.$refs.form.setValue('nutritionTableFile', null);
        this.nutritionTableFileRemoved = true;
      }
    });
  }

  public getData() {
    return {
      ...this.$refs.form.form,
    };
  }
}
